import type { OptionLookup, SearchableOption } from "./types";

export function filterOptions(options: SearchableOption[]): OptionLookup {
  return (query) => {
    const tokens = query.toLowerCase().split(/\s+/).filter((token) => token !== "");
    if (tokens.length === 0) return options;

    return options.filter((option) => {
      const haystack = `${option.label} ${option.desc ?? ""}`.toLowerCase();
      return tokens.every((token) => haystack.includes(token));
    });
  };
}
